module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "primary": ""
    }
  }, [_vm._v("lock")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Autentificare")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "email",
    attrs: {
      "rules": [_vm.rules.required, _vm.rules.email],
      "type": "email",
      "name": "email",
      "label": "Email",
      "id": "email",
      "prepend-icon": "email",
      "hint": "email"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "password",
    attrs: {
      "rules": [_vm.rules.required],
      "type": _vm.showPassword ? 'text' : 'password',
      "name": "password",
      "label": "Parola",
      "id": "password",
      "prepend-icon": "vpn_key",
      "hint": "parola",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "append-icon-cb": _vm.toggleShowPassword
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login($event)
      }
    }
  }, [_vm._v("Autentifica-te")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4225cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 600
// module chunks = 12